module.exports = __webpack_public_path__ + "img/volunteer-welcome-modal-header.2a67d67f.png";